import styled from 'styled-components';
import {injectAdaptive, injectSafeTop} from 'ui/theme';

export const Wrapper = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  background: ${(p) => p.theme.dark};

  &.is-enter-active,
  &.is-exit-active {
    ${(p) => p.theme.defaultAnimationStyle}
  }

  &.is-enter,
  &.is-exit-active {
    transform: translateX(100vw);
    opacity: 0;
  }

  &.is-enter-active {
    transform: translateX(0);
    opacity: 1;
  }
`;

export const Compensator = styled.div`
  position: relative;
  min-height: 100%;

  ${injectAdaptive('padding-bottom', ['320px', '330px', '340px', '340px', '340px'])}
  ${injectSafeTop('padding')}
`;
